export default function (find, replace, options) {
  const string = options.fn(this);
  return string.replace(find, replace);
}